import { cva } from '@/styled-system/css';

export const comboboxOptionLabelRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'label',
    textStyle: 'body',
    color: { base: 'Combobox.OptionLabel.text.label.default' },
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'Combobox.OptionLabel.text.label.hover',
          _groupActive: 'Combobox.OptionLabel.text.label.pressed',
        },
      },
    },
    selected: {
      true: {
        color: { base: 'Combobox.OptionLabel.text.label.selected' },
        textStyle: 'body-bold',
      },
      false: {},
    },
  },
});
